const authModel = {
  isLoggedIn: false,
  user: null
}

export default authModel;
